import moment from 'moment';
import template from 'product-social-links.j2';
import { getCurrentTimeInSeconds } from '@core/js/utils/dateUtils';
import { generate } from '@core/js/utils/componentUtils';
import { dDom } from '@core/js/utils/renderUtils';
import { onStateChange } from '../utils/productComponentUtils';

/**
 * Attach component events to DOM
 * @param {object} store The store
 */
function attachEvents(store) {
    const currentDate = getCurrentTimeInSeconds();
    let formattedDate = '';
    const dateFormat = 'YYYY-MM-DD';
    const timestamp = parseInt(currentDate, 10);
    const utc = moment.unix(timestamp).utc();

    formattedDate = utc.format(dateFormat);

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-product-facebook'), (e) => {
        e.preventDefault();

        const gaTag = $(e.currentTarget).attr('data-ga-link-track');
        const canonicalUrl = $(e.target).closest('.js-product-social-links').attr('data-canonical');
        const facebookUrl = encodeURIComponent(`${canonicalUrl}?utm_source=facebook&utm_campaign=PDP_SHARE&utm_medium=SOCIAL&utm_content=${formattedDate}`);

        window.open(`https://www.facebook.com/sharer/sharer.php?u=${facebookUrl}`, 'facebook-share', 'width=626,height=436,resizable=1');
    });

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-product-pinterest'), (e) => {
        e.preventDefault();

        const productImageUrl = $(e.target).closest('.js-product-social-links')
                                           .attr('data-product-image');

        const canonicalUrl = $(e.target).closest('.js-product-social-links')
                                        .attr('data-canonical');

        const pinterestUrl = encodeURIComponent(
            `${canonicalUrl}?utm_source=pinterest&utm_campaign=PDP_SHARE&utm_medium=SOCIAL&utm_content=${formattedDate}`
        );

        window.open(
            `https://www.pinterest.com/pin/create/button/?url=${pinterestUrl}&media=${productImageUrl}`,
            'pin',
            'width=775,height=640,resizable=0'
        );
    });

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-product-twitter'), (e) => {
        e.preventDefault();

        const state = store.getState();
        const productName = $(e.target).closest('.js-product-social-links').attr('data-product-name');
        const gaTag = $(e.currentTarget).attr('data-ga-link-track');
        const canonicalUrl = $(e.target).closest('.js-product-social-links').attr('data-canonical');

        let postUrlText = '';

        if (state.core.localizations.containers.chromeLocalization &&
            state.core.localizations.containers.chromeLocalization['product_social-twitter-post']) {
            postUrlText = state.core.localizations.containers.chromeLocalization['product_social-twitter-post'];
        } else if (state.core.constants.thirdParty[state.core.siteId] &&
            state.core.constants.thirdParty[state.core.siteId].twitter &&
            state.core.constants.thirdParty[state.core.siteId].twitter.userName) {
            postUrlText = state.core.constants.thirdParty[state.core.siteId].twitter.userName;
        }

        const twitterUrl = encodeURIComponent(`${productName} ${canonicalUrl}?utm_source=twitter&utm_campaign=PDP_SHARE&utm_medium=SOCIAL&utm_content=${formattedDate} ${postUrlText}`);

        window.open(`https://twitter.com/intent/tweet?text=${twitterUrl}`, 'tweet', 'height=300,width=550,resizable=1');
    });
}

export function init(store, overrides = {}) {
    const config = {
        watch: 'product.product.productId',
        templateLocation: '.dom-pdp .dom-product-social-links',
        attachEvents: attachEvents,
        onStateChange: onStateChange,
        renderType: dDom,
        template: template,
        name: 'productSocialComponent'
    };

    return generate(config, store, overrides);
}
